import React from "react";
import styles from "./styles.module.css";
import logo from "../../assets/logo.png";
import HRLinks from "./HRLinks";

const Navbar = ({ name, role }) => {
  return (
    <div className={styles.navigation}>
      <div className={styles.userContainer}>
        <div className={styles.logo}>
          <img src={logo} alt="Logo" />
        </div>
      </div>
      <HRLinks name={name} roles={role} />
    </div>
  );
};

export default Navbar;
